import { zodResolver } from '@hookform/resolvers/zod'
import {
  Button,
  Divider,
  Grid,
  IconButton,
  TextField,
  Dialog,
  DialogContent,
  TextField as TextFieldMt,
} from '@mui/material'
import dayjs from 'dayjs'
import { useContext, useState } from 'react'
import { MdClose, MdMedicalServices } from 'react-icons/md'
import { z } from 'zod'
import { AgendaContext } from '../..'
import { GlobalContext } from '../../../../../App'
import { metodoPrograma } from '../../../../../components/api'
import { Actions } from './components/actions'
import { TextStatics } from '../TextStatics'
import AutoComplete from '../../../../../components/AutoComplete/AutoComplete'
import { Controller, useForm } from 'react-hook-form'
import PrimeTable from '../../../../../components/PrimeTable'
import { setError } from '../../../../../components/alerts'
import { MedicationLiquid } from '@mui/icons-material'
import ModalConfirmacaoSenha from './components/ModalConfirmacaoSenha'
import ModalEvolucaoPaciente from './components/ModalEvolucaoPaciente'
import { useModal } from '../../../../../components/Utils/UseModal'

const createAgendamento = z.object({
  idAgendamento: z.number().nullable(),
  idLocalAtendimento: z.number(),
  idAgenda: z.number(),
  dtInicio: z.string(),
  dtFim: z.string(),
  idPaciente: z.number().nullable(),
  idAtendimento: z.number().nullable().optional(),
  dsObservacao: z.string().optional(),
  dtExclusao: z.string().nullable().optional(),
  acAtendimento: z.array(z.any()).nullable().optional(),
})

const initialValues = (
  agendamentoSelecionado,
  medico,
  agenda,
  localAtendimento,
) => ({
  nmMedico: medico?.nmMedico,
  idAgendamento: agendamentoSelecionado.data?.[0] || null,
  idLocalAtendimento: localAtendimento[0],
  idAgenda: agendamentoSelecionado?.data?.[4],
  acAgenda: [
    [agendamentoSelecionado.data?.[4]],
    agendamentoSelecionado.data?.[5],
  ],
  dtInicio: agendamentoSelecionado.start
    ? dayjs(agendamentoSelecionado.start).format('YYYY-MM-DD HH:mm')
    : '',
  dtFim: agendamentoSelecionado.end
    ? dayjs(agendamentoSelecionado.end).format('YYYY-MM-DD HH:mm')
    : '',
  idPaciente: agendamentoSelecionado.data?.idPaciente || null,
  idAtendimento: agendamentoSelecionado.data?.idAtendimento || null,
  dsObservacao: agendamentoSelecionado.data?.[8] || '',
})

export const ScheduleEditor = ({ listaAgendamentos }) => {
  const { agendamentoSelecionado, medico, dispatch } = useContext(AgendaContext)
  const { agenda, localAtendimento, usuarioLogado } = useContext(GlobalContext)
  const [reloadAtendimento, setReloadAtendimento] = useState(false)
  const openModal = useModal(ModalConfirmacaoSenha)
  const openEvolucao = useModal(ModalEvolucaoPaciente)

  const [idAtendimento, idPaciente] = agendamentoSelecionado.resourceId
    .split('-')
    .map(Number)

  const { register, handleSubmit, watch, setValue, control } = useForm({
    defaultValues: initialValues(
      agendamentoSelecionado,
      medico,
      agenda,
      localAtendimento,
    ),
    resolver: zodResolver(createAgendamento),
  })
  const restringeHorarioEAgenda =
    Number(usuarioLogado?.id) === 45 && Boolean(watch('idAgendamento'))

  const salvar = async (values) => {
    proceedWithAppointmentConfirmation(values, true)
  }

  const alteraHorario = (campo, horario) => {
    const dataHoraAtual = watch(campo)

    if (!dataHoraAtual || !horario) return

    const [hora, minuto] = horario.split(':').map(Number)
    const novaDataHora = dayjs(dataHoraAtual)
      .hour(hora)
      .minute(minuto)
      .second(0)

    setValue(campo, novaDataHora.format('YYYY-MM-DD HH:mm'), {
      shouldDirty: true,
      shouldValidate: true,
    })
  }

  const proceedWithAppointmentConfirmation = async (
    values,
    fechaModal = false,
  ) => {
    const obj = {
      ...values,
      dtInicio: values.dtInicio
        ? dayjs(values.dtInicio).format('YYYY-MM-DD HH:mm')
        : undefined,
      dtFim: values.dtFim
        ? dayjs(values.dtFim).format('YYYY-MM-DD HH:mm')
        : undefined,
      idAtendimento,
      idPaciente,
    }

    const res = await metodoPrograma('salva', obj)

    if (res.status) {
      listaAgendamentos()

      setValue('idAgendamento', res.idAgendamento)
      if (fechaModal) {
        dispatch({
          field: 'agendamentoSelecionado',
          value: { data: null, modal: false },
        })
      }

      return res.idAgendamento
    }

    return null
  }

  const fecharModal = () => {
    listaAgendamentos()
    dispatch({
      field: 'agendamentoSelecionado',
      value: { data: null, modal: false },
    })
  }

  const garantirAgendamentoSalvo = async () => {
    const idAgendamento = watch('idAgendamento')

    if (idAgendamento) {
      return idAgendamento
    }
    const values = {
      dtInicio: watch('dtInicio'),
      dtFim: watch('dtFim'),
      idAgenda: watch('idAgenda'),
      idLocalAtendimento: watch('idLocalAtendimento'),
      dsObservacao: watch('dsObservacao'),
    }

    const novoId = await proceedWithAppointmentConfirmation(values)

    if (!novoId) {
      setError('Erro ao salvar agendamento')
      return null
    }

    return novoId
  }

  const salvarAplicacaoAgendamento = async (valuesTabela) => {
    const partes = agendamentoSelecionado.resourceId.split('-')

    const idAgendamento = await garantirAgendamentoSalvo()

    if (!idAgendamento) return

    const payload = {
      idAgendamento,
      idAtendimento: partes[0],
      idPaciente: partes[1],
      idProduto: valuesTabela?.acProduto?.[0]?.[0],
      dsObservacao: valuesTabela?.dsObservacao,
    }

    const resp = await metodoPrograma('salvarAplicacaoAgendamento', payload)

    if (resp.status) {
      setReloadAtendimento((v) => !v)
    }
  }

  const excluiAplicacaoAgendamento = async (values) => {
    const payload = {
      idAgendamento: values?.[0],
      idProduto: values?.[1]?.[0]?.[0],
    }

    const resp = await metodoPrograma('excluiAplicacaoAgendamento', payload)
    if (resp.status) {
      setReloadAtendimento((v) => !v)
    }
  }

  const registraAplicacaoAgendamento = async (values) => {
    const payload = {
      idAgendamento: values?.[0],
      idProduto: values?.[1]?.[0]?.[0],
      setReloadAtendimento,
    }
    await openModal(payload)
  }

  const formatDateHour = (value) => {
    if (!value) return ''

    const d = new Date(value)
    if (isNaN(d)) return value

    const dia = String(d.getDate()).padStart(2, '0')
    const mes = String(d.getMonth() + 1).padStart(2, '0')
    const ano = d.getFullYear()

    const hora = String(d.getHours()).padStart(2, '0')
    const min = String(d.getMinutes()).padStart(2, '0')
    const seg = String(d.getSeconds()).padStart(2, '0')

    return `${dia}/${mes}/${ano} ${hora}:${min}:${seg}`
  }

  console.log('agendamentoSelecionado', agendamentoSelecionado)

  return (
    <Dialog
      open={agendamentoSelecionado.modal}
      onClose={fecharModal}
      maxWidth="lg"
      fullWidth
    >
      <DialogContent>
        <div className="overflow-x-hidden p-4">
          <form
            onSubmit={handleSubmit(salvar, (errors) => {
              console.log('ERROS DO FORM:', errors)
            })}
            style={{ padding: '1rem' }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} className="flex justify-between">
                <TextStatics
                  tpEstado={agendamentoSelecionado.data?.[5]?.tpEstado}
                />
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    startIcon={<MdMedicalServices />}
                    disabled={!watch('idAgendamento')}
                    onClick={() =>
                      openEvolucao({
                        idPaciente:
                          agendamentoSelecionado.data?.idPaciente ??
                          Number(
                            agendamentoSelecionado.resourceId?.split('-')[1],
                          ),
                        data: dayjs(agendamentoSelecionado.start).format(
                          'YYYY-MM-DD',
                        ),
                        idLocalAtendimento: localAtendimento[0],
                      })
                    }
                  >
                    Evolução de Enfermagem
                  </Button>
                  <IconButton
                    title="Fechar modal"
                    onClick={() => fecharModal()}
                  >
                    <MdClose />
                  </IconButton>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controller
                  name="dtInicio"
                  control={control}
                  render={({ field: { value, onBlur, ref } }) => (
                    <TextField
                      fullWidth
                      inputRef={ref}
                      label="Hora Início"
                      type="time"
                      value={value ? dayjs(value).format('HH:mm') : ''}
                      size="small"
                      disabled={restringeHorarioEAgenda}
                      onChange={(e) =>
                        alteraHorario('dtInicio', e.target.value)
                      }
                      onBlur={onBlur}
                      variant="outlined"
                      margin="dense"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controller
                  name="dtFim"
                  control={control}
                  render={({ field: { value, onBlur, ref } }) => (
                    <TextField
                      fullWidth
                      inputRef={ref}
                      label="Hora Fim"
                      size="small"
                      type="time"
                      disabled={restringeHorarioEAgenda}
                      value={value ? dayjs(value).format('HH:mm') : ''}
                      onChange={(e) => alteraHorario('dtFim', e.target.value)}
                      onBlur={onBlur}
                      variant="outlined"
                      margin="dense"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  {...register('nmMedico')}
                  fullWidth
                  label="Profissional"
                  size="small"
                  type="text"
                  disabled
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <AutoComplete
                  InputLabelProps={{ shrink: true }}
                  label="Agenda"
                  metodo="buscaAgendaProgramacao"
                  disabled={restringeHorarioEAgenda}
                  value={watch('acAgenda')}
                  searchParams={{
                    idAtendimento,
                    idPaciente,
                  }}
                  getOptionLabel={(item) =>
                    Array.isArray(item) && item.length > 0
                      ? `${item?.[1] ?? ''}`
                      : ''
                  }
                  getOptionSelected={(option, value) =>
                    option?.[0]?.[0] === value?.[0]?.[0]
                  }
                  {...register('acAgenda')}
                  onChange={(_, value) => {
                    setValue('idAgenda', value?.[0]?.[0] || null)
                    setValue('dsAgenda', value?.[1] || '')
                    setValue('acAgenda', value || '')
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <TextField
                  {...register('dsObservacao')}
                  fullWidth
                  label="Observação"
                  variant="outlined"
                  size="small"
                  margin="dense"
                  disabled={
                    watch('tpEstado') !== undefined && watch('tpEstado') === '6'
                  }
                />
              </Grid>
              {watch('idAgenda') === 54 && (
                <Grid item md={12}>
                  <PrimeTable
                    action="listaAplicacaoAgendamento"
                    codigo="CtrlProgramacaoAgendaCheckin"
                    parametros={{ idAgendamento: watch('idAgendamento') || -1 }}
                    autocompleteEditableIndex={[0]}
                    actionResponse={(resp) =>
                      dispatch({
                        type: 'dadosEdicao',
                        field: 'listPacotes',
                        value: resp?.lista || [],
                      })
                    }
                    head={[
                      'Aplicação',
                      'Registrado por',
                      'Aplicado por',
                      'Informações',
                    ]}
                    refresh={reloadAtendimento}
                    line={(item) => [
                      item?.[1]?.[1],
                      <>
                        {item?.[2]?.[1]}
                        <br />
                        {formatDateHour(item?.[3])}
                      </>,
                      <>
                        {item?.[4]?.[1] ? (
                          <>
                            {item?.[4]?.[1]}
                            <br />
                            {formatDateHour(item?.[5])}
                          </>
                        ) : (
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<MedicationLiquid />}
                            onClick={() => registraAplicacaoAgendamento(item)}
                          >
                            Aplicar
                          </Button>
                        )}
                      </>,
                      item?.[6],
                    ]}
                    rows={100000}
                    editButton={false}
                    addButton={true}
                    disablePagination
                    onDelete={{ index: 10, action: excluiAplicacaoAgendamento }}
                    fastAddComponent={({ values, edit, close }) => (
                      <Grid container spacing={2}>
                        <Grid item md={12}>
                          <AutoComplete
                            metodo="buscaProdutoAplicacao"
                            codigo="CtrlProposta"
                            value={values?.acProduto}
                            searchParams={{
                              idAtendimento,
                              idPaciente,
                            }}
                            name="acProduto"
                            label="Produto"
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            size="small"
                            onChange={async (_, val) => {
                              await edit({
                                value: val,
                                field: 'acProduto',
                              })
                            }}
                            textFieldProps={{
                              helperText: !values?.acProduto
                                ? 'Campo Obrigatório!'
                                : '',
                              error: !values?.acProduto,
                            }}
                          />
                        </Grid>
                        <Grid item md={12}>
                          <TextFieldMt
                            InputLabelProps={{ shrink: true }}
                            name="dsObservacao"
                            label="Informações da Aplicação"
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            size="small"
                            value={values?.dsObservacao}
                            onChange={(e) =>
                              edit({
                                value: e.target.value,
                                field: 'dsObservacao',
                              })
                            }
                          />
                        </Grid>
                        <Grid
                          item
                          container
                          md={12}
                          spacing={2}
                          justifyContent="flex-end"
                        >
                          <Grid item md={6}>
                            <Button
                              onClick={close}
                              fullWidth
                              variant="contained"
                              color="inherit"
                              style={{ margin: '5px' }}
                            >
                              Cancelar
                            </Button>
                          </Grid>
                          <Grid item md={6}>
                            <Button
                              onClick={() =>
                                !!values?.acProduto &&
                                salvarAplicacaoAgendamento(values) &&
                                close()
                              }
                              variant="contained"
                              fullWidth
                              color="primary"
                              style={{ margin: '5px' }}
                            >
                              Salvar
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  />
                </Grid>
              )}

              <Grid item xs={12}>
                <p
                  style={{
                    fontWeight: '400',
                    fontSize: '14px',
                    display: 'flex',
                    margin: '0px, 0px, 0px, 4px',
                    padding: '0px, 0px, 0px, 4px',
                  }}
                >
                  {agendamentoSelecionado.data?.[12] && (
                    <span>
                      Realizou em{' '}
                      <b>
                        {agendamentoSelecionado.data[12]
                          ? dayjs(agendamentoSelecionado.data[12]).format(
                              'DD/MM/YYYY HH:mm',
                            )
                          : ''}
                      </b>
                    </span>
                  )}
                  {agendamentoSelecionado.data?.[11] && (
                    <span style={{ marginLeft: '20px' }}>
                      Chegou às{' '}
                      <b>
                        {agendamentoSelecionado.data[11]
                          ? dayjs(agendamentoSelecionado.data[11]).format(
                              'HH:mm',
                            )
                          : ''}
                      </b>
                    </span>
                  )}
                </p>
              </Grid>
              <Grid item xs={12} sm={4} />
              <Actions
                fecharModal={fecharModal}
                dtExclusao={watch('dtExclusao')}
                dtConfirmouComparecimento={agendamentoSelecionado.data?.[12]}
                idAgendamento={watch('idAgendamento')}
                tpEstado={watch('tpEstado')}
              />
            </Grid>
          </form>
        </div>
      </DialogContent>
    </Dialog>
  )
}
